export default __webpack_public_path__ + "static/media/coin-icon.d079865b.svg";